// Pull the most user-friendly error string out of an axios/react-query
// rejection. Server errors come in via err.response.data.message; runtime
// errors via err.message. Falls back to a caller-supplied label so empty
// strings never bubble up to toasts.
export const errorMessage = (err, fallback) =>
  err?.response?.data?.message || err?.message || fallback
